import React, { useMemo } from 'react';
import { Autocomplete, ChipButton, CloseButton, Tooltip, Typography } from 'seagull';
import styles from "./PMMapServiceField.module.scss";
function isPracticeManagementIntegrationItem(item) {
  return typeof item !== 'string';
}
export default function PMMapServiceField(props) {
  const {
    testid,
    value,
    options,
    loading,
    disabled,
    tooltip,
    label,
    onChange: _onChange
  } = props;
  const selectedOptions = useMemo(() => {
    return options ? options.filter(opt => value.includes(opt.id)) : [];
  }, [value, options]);
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: tooltip ? /*#__PURE__*/React.createElement("div", {
      "data-testid": "".concat(testid, "-tooltip")
    }, tooltip) : ''
  }, /*#__PURE__*/React.createElement("div", {
    "data-testid": "".concat(testid, "-wrapper")
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    multiple: true,
    disableCloseOnSelect: true,
    filterSelectedOptions: true,
    id: testid,
    "data-testid": testid,
    loading: loading,
    disabled: disabled || loading,
    options: options || [],
    getOptionLabel: opt => opt.name
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ,
    value: selectedOptions // for some reason, TS doesn't like the real type even though it's correct
    ,
    textFieldProps: {
      label,
      placeholder: selectedOptions.length > 0 ? '' : 'Not mapped',
      alwaysShrinkLabel: true
    },
    onChange: (e, value) => _onChange(value.filter(isPracticeManagementIntegrationItem).map(item => item.id)),
    renderTags: (value, getTagProps) => value.map((opt, index) => {
      const tagProps = getTagProps({
        index
      }); // eslint-disable-line @typescript-eslint/no-explicit-any
      return /*#__PURE__*/React.createElement(ChipButton, {
        highlight: true,
        key: opt.id,
        disabled: disabled || loading,
        className: styles.badge,
        "data-testid": "".concat(testid, "-tag-").concat(index)
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "paragraph2"
      }, opt.name), /*#__PURE__*/React.createElement(CloseButton, {
        size: "xsmall",
        bordered: true,
        disabled: disabled || loading,
        onClick: tagProps.onDelete
      }));
    })
  })));
}